import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import LiveStream from '../views/LiveStream.vue';
import AudioMessage from '../views/AudioMessage.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/library/stream/:id',
    name: 'LiveStream',
    component: LiveStream,
  },
  {
    path: '/audio-message/:id',
    name: 'AudioMessage',
    component: AudioMessage,
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
